import React, { useState, useEffect } from 'react';
import { smtpService } from '../services/api.service';
import { COLORS } from '../config/constants';

const SMTPSettings = () => {
  const [settings, setSettings] = useState({
    smtp_server: '',
    smtp_port: 587,
    smtp_username: '',
    smtp_password: '',
    from_email: '',
    from_name: 'ABELL Factory System',
    use_tls: true
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [hasSettings, setHasSettings] = useState(false);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await smtpService.getSettings();
      if (data) {
        setSettings({
          smtp_server: data.smtp_server || '',
          smtp_port: data.smtp_port || 587,
          smtp_username: data.smtp_username || '',
          smtp_password: '', // Don't load password
          from_email: data.from_email || '',
          from_name: data.from_name || 'ABELL Factory System',
          use_tls: data.use_tls !== undefined ? data.use_tls : true
        });
        setHasSettings(true);
      }
    } catch (error) {
      console.error('SMTP ayarları yüklenemedi:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      if (hasSettings) {
        await smtpService.updateSettings(settings);
        setMessage({ type: 'success', text: 'SMTP ayarları güncellendi!' });
      } else {
        await smtpService.saveSettings(settings);
        setMessage({ type: 'success', text: 'SMTP ayarları kaydedildi!' });
        setHasSettings(true);
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Kaydetme başarısız: ' + (error.response?.data?.detail || error.message) });
    } finally {
      setLoading(false);
    }
  };

  const handleTest = async () => {
    setTesting(true);
    setMessage({ type: '', text: '' });

    try {
      await smtpService.testConnection();
      setMessage({ type: 'success', text: 'Test maili başarıyla gönderildi! Mail kutunuzu kontrol edin.' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Test başarısız: ' + (error.response?.data?.detail || error.message) });
    } finally {
      setTesting(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('SMTP ayarlarını silmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      await smtpService.deleteSettings();
      setSettings({
        smtp_server: '',
        smtp_port: 587,
        smtp_username: '',
        smtp_password: '',
        from_email: '',
        from_name: 'ABELL Factory System',
        use_tls: true
      });
      setHasSettings(false);
      setMessage({ type: 'success', text: 'SMTP ayarları silindi!' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Silme başarısız!' });
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2 style={{ color: COLORS.primary, marginBottom: '1.5rem' }}>📧 Mail Ayarları (SMTP)</h2>
      
      {message.text && (
        <div style={{
          padding: '1rem',
          borderRadius: '8px',
          marginBottom: '1.5rem',
          background: message.type === 'success' ? '#d1fae5' : '#fee2e2',
          color: message.type === 'success' ? '#065f46' : '#991b1b'
        }}>
          {message.text}
        </div>
      )}

      <div style={{
        background: '#FFFFFF',
        borderRadius: '12px',
        padding: '2rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                SMTP Sunucu *
              </label>
              <input
                type="text"
                value={settings.smtp_server}
                onChange={(e) => setSettings({...settings, smtp_server: e.target.value})}
                placeholder="smtp.hostinger.com"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #E8E8E8',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                SMTP Port *
              </label>
              <input
                type="number"
                value={settings.smtp_port}
                onChange={(e) => setSettings({...settings, smtp_port: parseInt(e.target.value)})}
                placeholder="587"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #E8E8E8',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Kullanıcı Adı (Email) *
              </label>
              <input
                type="email"
                value={settings.smtp_username}
                onChange={(e) => setSettings({...settings, smtp_username: e.target.value})}
                placeholder="info@abellms.com"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #E8E8E8',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Şifre *
              </label>
              <input
                type="password"
                value={settings.smtp_password}
                onChange={(e) => setSettings({...settings, smtp_password: e.target.value})}
                placeholder={hasSettings ? "Değiştirmek için yeni şifre girin" : "Mail şifreniz"}
                required={!hasSettings}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #E8E8E8',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Gönderen Email *
              </label>
              <input
                type="email"
                value={settings.from_email}
                onChange={(e) => setSettings({...settings, from_email: e.target.value})}
                placeholder="info@abellms.com"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #E8E8E8',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Gönderen İsim
              </label>
              <input
                type="text"
                value={settings.from_name}
                onChange={(e) => setSettings({...settings, from_name: e.target.value})}
                placeholder="ABELL Factory System"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '2px solid #E8E8E8',
                  borderRadius: '8px',
                  fontSize: '1rem'
                }}
              />
            </div>
          </div>

          <div style={{ marginTop: '1.5rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={settings.use_tls}
                onChange={(e) => setSettings({...settings, use_tls: e.target.checked})}
                style={{ width: '18px', height: '18px' }}
              />
              <span>TLS Kullan (Önerilen)</span>
            </label>
          </div>

          <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '0.875rem 2rem',
                background: 'linear-gradient(135deg, #E40A04 0%, #B00803 100%)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '10px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Kaydediliyor...' : (hasSettings ? 'Güncelle' : 'Kaydet')}
            </button>

            {hasSettings && (
              <>
                <button
                  type="button"
                  onClick={handleTest}
                  disabled={testing}
                  style={{
                    padding: '0.875rem 2rem',
                    background: '#10B981',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: testing ? 'not-allowed' : 'pointer',
                    opacity: testing ? 0.6 : 1
                  }}
                >
                  {testing ? 'Test Ediliyor...' : '✉️ Test Et'}
                </button>

                <button
                  type="button"
                  onClick={handleDelete}
                  style={{
                    padding: '0.875rem 2rem',
                    background: '#DC2626',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  🗑️ Sil
                </button>
              </>
            )}
          </div>
        </form>

        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          background: '#F3F4F6',
          borderRadius: '8px',
          fontSize: '0.9rem',
          color: '#666'
        }}>
          <p style={{ margin: 0, marginBottom: '0.5rem' }}><strong>💡 Hostinger Mail Ayarları:</strong></p>
          <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
            <li>SMTP Sunucu: <code>smtp.hostinger.com</code></li>
            <li>Port: <code>587</code> (TLS) veya <code>465</code> (SSL)</li>
            <li>Kullanıcı Adı: Mail adresiniz (örn: info@abellms.com)</li>
            <li>Şifre: Hostinger mail şifreniz</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SMTPSettings;
